import { FunctionComponent } from "react";
import { SecaoButao } from "../../../../components/formulario/styled";
import ModalExportar from "../../../../components/modalExportar";
import SearchInput from "../../../../components/inputs/searchInput";
import OpenExcelUniversal from "../../../../components/excel/OpenExcelUniversal";
import DonwloadPdf from "../../../../components/pdf/DonwloadPdf";
import { useServicesEventosCheckin } from "../context/getServicesEventos";
import ModalCreateEventoCheckin from "./create";


interface HeaderEventoChekinProps {

}

const HeaderEventoChekin: FunctionComponent<HeaderEventoChekinProps> = () => {

  const { listAll, getSearchPerMiniter } = useServicesEventosCheckin()

  return (<>
    <SecaoButao style={{ marginBottom: 5 }}>
      <section style={{ display: 'flex', gap: 5 }}>
        <ModalExportar
          callDownloadExcel={() => OpenExcelUniversal(listAll, ['nomegrupo', 'descricao', 'cargopai', 'codigo'])}
          callDownloadPdf={() => DonwloadPdf(listAll, ['Grupo Cargo', 'Descrição', 'Cargo Pai', 'Código'],
            ['nomegrupo', 'descricao', 'cargopai', 'codigo'], listAll?.length, [], `${listAll?.length}`)
          }
        />

      </section>
      <SearchInput
        placeholder="Procure por evento"
        onChange={getSearchPerMiniter}
      />

      {/* <ModalCreateEventoCheckin /> */}
    </SecaoButao>
  </>);
}

export default HeaderEventoChekin;
